import { useState } from 'react';

const SUBMIT_URL = 'https://readdy.ai/api/form/da22n0rk8r5te5mqser0';

export default function NewsletterForm() {
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);

    // 蜜罐检测
    const honeypot = (fd.get('website_alt') as string) || '';
    if (honeypot.trim()) {
      setStatus('success');
      return;
    }

    const email = (fd.get('email') as string) || '';
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setStatus('error');
      setFormError('请输入有效的邮箱地址。');
      return;
    }

    fd.delete('website_alt');

    try {
      const res = await fetch(SUBMIT_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(fd as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed: any = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '';
      if (res.ok && parsed?.code === 'OK') {
        setStatus('success');
        form.reset();
      } else {
        setStatus('error');
        setFormError(serverMsg || '提交失败，请稍后再试。');
      }
    } catch {
      setStatus('error');
      setFormError('网络异常，请稍后再试。');
    }
  };

  return (
    <div
      className="rounded-2xl bg-primary-500 px-6 py-10 text-center md:px-10"
      style={{ backgroundImage: 'linear-gradient(120deg, oklch(var(--primary-500)), oklch(var(--primary-600)))' }}
    >
      <h3 className="font-heading text-2xl font-bold text-background-50 md:text-3xl">
        订阅樱花漫画网更新通知
      </h3>
      <p className="mx-auto mt-3 max-w-xl text-sm text-primary-50">
        留下邮箱，每当少女漫画、恋爱漫画或热门日漫新番更新时，第一时间收到追更提醒，不错过任何心动瞬间。
      </p>

      {status === 'success' ? (
        <div className="mx-auto mt-6 max-w-md rounded-xl bg-background-50/15 px-5 py-4 text-background-50">
          <i className="ri-checkbox-circle-fill mr-2 text-xl"></i>
          订阅成功！我们会定期为你推送最新漫画更新，感谢支持。
        </div>
      ) : (
        <form
          data-readdy-form
          onSubmit={handleSubmit}
          className="mx-auto mt-6 flex max-w-md flex-col gap-3 sm:flex-row"
        >
          <label className="sr-only" htmlFor="nl-email">邮箱地址</label>
          <input
            id="nl-email"
            type="email"
            name="email"
            required
            placeholder="输入你的邮箱地址"
            className="w-full rounded-full bg-background-50 px-5 py-3 text-sm text-foreground-900 outline-none placeholder:text-foreground-400 focus:ring-2 focus:ring-accent-400"
          />
          <button
            type="submit"
            className="rounded-full bg-accent-500 px-6 py-3 text-sm font-semibold text-background-50 whitespace-nowrap transition hover:bg-accent-600"
          >
            立即订阅
          </button>
          <input
            type="text"
            name="website_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
            className="hp-field"
          />
        </form>
      )}

      {status === 'error' && (
        <p className="mt-4 text-sm text-primary-50">{formError}</p>
      )}
    </div>
  );
}